import { struct, union } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as ParameterId } from '../../../../whole-house/additional-parameter/Id';

export const Request = union(
	struct({
		organizationId: OrganizationId,
	}),
	struct({
		parameterId: ParameterId,
	})
);
